(()=>{
  document.querySelectorAll('[data-prototype-video]').forEach(video=>{
    const motion=matchMedia('(prefers-reduced-motion: reduce)');
    let near=false;
    let userPaused=false;
    let automaticPause=false;
    const load=()=>{
      if(video.hasAttribute('src'))return;
      video.src=video.dataset.src;
      video.load();
    };
    const pause=()=>{
      if(video.paused)return;
      automaticPause=true;
      video.pause();
    };
    const play=()=>{
      if(!near||document.hidden||motion.matches||userPaused)return;
      load();
      const result=video.play();
      if(result)result.then(()=>{if(!near||document.hidden||motion.matches)pause();}).catch(()=>{});
    };
    video.addEventListener('pause',()=>{
      if(automaticPause){automaticPause=false;return;}
      userPaused=true;
    });
    video.addEventListener('play',()=>{userPaused=false;});
    video.addEventListener('pointerdown',load,{once:true});
    video.addEventListener('keydown',load,{once:true});
    document.addEventListener('visibilitychange',()=>{if(document.hidden)pause();else play();});
    motion.addEventListener('change',()=>{if(motion.matches)pause();else play();});
    if(!('IntersectionObserver' in window)){load();return;}
    const preload=new IntersectionObserver(entries=>{
      if(entries.some(entry=>entry.isIntersecting)){load();preload.disconnect();}
    },{rootMargin:'240px 0px',threshold:0});
    const playback=new IntersectionObserver(entries=>{
      near=entries.some(entry=>entry.isIntersecting);
      if(near)play();else pause();
    },{rootMargin:'0px 0px 80px 0px',threshold:0.01});
    preload.observe(video);
    playback.observe(video);
  });
})();
